import 'at-internet-smarttag-manager-eu'; // eslint-disable-line
/* eslint-disable */
import { initializeReact, setUserInformation } from '@uxmanagers/ovh-sentry-browser';

(function(window) {
  initializeReact(
	'https://52214729a67569965ee90c39df04a195@sentry.ovhcloud.com/96',
	{
	  release: 'sulfur-elk-8',
	  environment: 'production',
	  tracesSampleRate: 'production' === 'staging' ? 1 : null,
	});

	window.addEventListener('sentry::user-information', function (event) {
		setUserInformation(event.detail);
	});
})(window);
/* eslint-enable */
